import * as React from 'react';
import Loader from '../../Component/Loader/Loader';
import { Button, Modal } from 'antd';

interface CRUDModalProps extends React.PropsWithChildren {
  onClose?: Function;
  onCancel?: Function;
  onSave?: Function;
  onOpen?: Function;
  openButton: React.ReactNode;
  editedObject?: any;
  modalTitle: string;
  closeAfterSave?: boolean;
}

interface CRUDModalState{
  loading: boolean;
  visible: boolean;
  error: any;
  submitting: boolean;
}

export default class CRUDModal extends React.Component<CRUDModalProps, CRUDModalState>{
  private loadingTitle: string = 'Please wait...';

  constructor(props: CRUDModalProps) {
    super(props);
    this.onShow = this.onShow.bind(this);
    this.onOk = this.onOk.bind(this);
    this.state = {
      visible: false,
      error: undefined,
      loading: true,
      submitting: false,
    }
  }

  async onShow() {
    const { onOpen } = this.props;
    this.setState({ visible: true });
    onOpen && onOpen();
    this.setState({ loading: false });
  }

  async onOk() {
    const { onSave, closeAfterSave } = this.props;
    if (onSave) {
      this.setState({ loading: true, submitting: true });
      const isOk = await onSave();
      this.setState({ loading: false, submitting: false, visible: !isOk });
    }
    if (closeAfterSave) {
      this.close();
    }
  }

  close() {
    this.setState({ ...this.state, visible: false });
  }

  render() {
    const { openButton, modalTitle, children } = this.props;
    const { visible, loading, submitting } = this.state;

    return (
      <>
        <Button type={'link'} onClick={this.onShow}>
          {openButton}
        </Button>
        <Modal
          visible={visible}
          confirmLoading={loading}
          onOk={this.onOk}
          onCancel={() => this.setState({ visible: false })}
          title={loading ? this.loadingTitle : modalTitle}
          okButtonProps={{ loading: submitting }}
          cancelButtonProps={{ disabled: submitting, style: { display: 'none' } }}
        >
          {loading && <Loader />}
          {children}
        </Modal>
      </>
    );
  }
}
